// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateAppButton_root__MFv\\+h {
  height: 48px;
  display: inline-flex;
  align-items: center;
  padding-left: 12px;
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: #4778EE;
  box-shadow: 0px 92px 37px rgba(71, 120, 238, 0.01), 0px 52px 31px rgba(71, 120, 238, 0.05), 0px 23px 23px rgba(71, 120, 238, 0.09), 0px 6px 13px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);
  border-radius: 8px;
  animation: 0.3s UpdateAppButton_appear__evysJ ease alternate;
  z-index: 2000;
}

.UpdateAppButton_icon__XO6Cd {
  line-height: 1;
  display: inline-flex;
}

.UpdateAppButton_content__Sj9Sg {
  margin-left: 10px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
}

.UpdateAppButton_button__4rd6b {
  background: transparent;
  border: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #FFFFFF;
  padding: 8px 16px;
  height: 100%;
  display: inline-flex;
  align-items: center;
}

@keyframes UpdateAppButton_appear__evysJ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 600px) {
  .UpdateAppButton_root__MFv\\+h {
    width: 300px;
    max-width: 95vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/UpdateAppButton/UpdateAppButton.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,6MAAA;EACA,kBAAA;EACA,4DAAA;EACA,aAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,UAAA;EACF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;IACA,eAAA;EADF;AACF","sourcesContent":[".root {\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  padding-left: 12px;\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #4778EE;\n  box-shadow: 0px 92px 37px rgba(71, 120, 238, 0.01), 0px 52px 31px rgba(71, 120, 238, 0.05), 0px 23px 23px rgba(71, 120, 238, 0.09), 0px 6px 13px rgba(71, 120, 238, 0.1), 0px 0px 0px rgba(71, 120, 238, 0.1);\n  border-radius: 8px;\n  animation: 0.3s appear ease alternate;\n  z-index: 2000;\n}\n\n.icon {\n  line-height: 1;\n  display: inline-flex;\n}\n\n.content {\n  margin-left: 10px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #FFFFFF;\n}\n\n.button {\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #FFFFFF;\n  padding: 8px 16px;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n}\n\n@keyframes appear {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@media(max-width: 600px) {\n  .root {\n    width: 300px;\n    max-width: 95vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UpdateAppButton_root__MFv+h`,
	"appear": `UpdateAppButton_appear__evysJ`,
	"icon": `UpdateAppButton_icon__XO6Cd`,
	"content": `UpdateAppButton_content__Sj9Sg`,
	"button": `UpdateAppButton_button__4rd6b`
};
export default ___CSS_LOADER_EXPORT___;
